import { DamageTypeEnum } from '@insurance/api/requests'
import { TFunction } from 'i18next'

export const damageTypeLabels: Record<DamageTypeEnum, string> = {
  [DamageTypeEnum._1]: 'damage_type_vehicle',
  [DamageTypeEnum._2]: 'damage_type_property',
  [DamageTypeEnum._3]: 'damage_type_bodily_injury'
}

const damageTypeList = Object.values(DamageTypeEnum).filter(
  (value): value is DamageTypeEnum => typeof value === 'number'
)

export const damageOptions = (t: TFunction) =>
  damageTypeList.map((value) => ({
    value,
    label: t(damageTypeLabels[value])
  }))
